import CalendarLoading from './CalendarLoading'

export default CalendarLoading
